import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const ResendButton = ({ u, onDone }) => (
  <Button size="sm" variant="outline" className="ml-2 h-7 px-2 text-xs" data-testid={`user-resend-${u.id}`}
    onClick={async (e) => { e.stopPropagation(); try { const r = await api.post(`/users/${u.id}/resend-invite`); toast[r.data.invite_status === "sent" ? "success" : "error"](r.data.invite_status === "sent" ? `Invito reinviato a ${u.email}` : `Invito a ${u.email} non recapitato`); onDone(); } catch (err) { toast.error(errMsg(err)); } }}>
    Reinvia
  </Button>
);

export const ExpiredInvites = ({ refreshKey, onDone }) => {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/users").then((r) => setUsers(r.data.filter((u) => u.invite_expired || (!u.has_password && u.active && u.invite_status === "failed")))).catch(() => {}); }, [refreshKey]);
  if (!users.length) return null;
  const all = async () => {
    try { const r = await api.post("/users/resend-expired"); toast.success(`${r.data.queued} inviti in partenza, uno ogni 4 secondi`); setTimeout(onDone, r.data.queued * 4000 + 3000); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mb-3 border border-amber-300 bg-amber-50 p-3" data-testid="expired-invites">
      <div className="flex flex-wrap items-center gap-3">
        <MailWarning className="h-5 w-5 text-amber-700" />
        <span className="text-sm font-semibold text-amber-900">{users.length === 1 ? "1 invito scaduto o non recapitato" : `${users.length} inviti scaduti o non recapitati`}</span>
        <Button size="sm" variant="ghost" onClick={() => setOpen(!open)} data-testid="expired-invites-filter">{open ? "Nascondi elenco" : "Mostra elenco"}</Button>
        <Button size="sm" className="ml-auto" onClick={all} data-testid="expired-invites-resend-all">Reinvia a tutti</Button>
      </div>
      {open && <div className="mt-2 divide-y border-t border-amber-200">{users.map((u) => (
        <div key={u.id} className="flex items-center justify-between py-1.5 text-sm" data-testid={`expired-invite-${u.id}`}>
          <span><b>{u.name}</b> <span className="font-mono text-xs">{u.email}</span> <span className="text-xs text-amber-800">{u.invite_status === "failed" ? "non recapitato" : `inviato il ${new Date(u.invite_sent_at).toLocaleDateString("it-IT")}`}{u.invite_auto_reminded && " · sollecito automatico già inviato"}</span></span>
          <ResendButton u={u} onDone={onDone} />
        </div>))}</div>}
    </div>
  );
};
